import React from 'react';
import Notifications from '../../../common/header/notifications';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withComponentId } from '../../../../common/ComponentIdContext';
import { REDUCER_NAME, fetchCompanyScore } from '../../reducer';

class NotificationsWrapper extends React.Component {
  componentDidUpdate(prevProps) {
    if (prevProps.i18n.locale !== this.props.i18n.locale) {
      const { dispatch, id, searchParams } = this.props;
      dispatch(fetchCompanyScore(id, searchParams.code));
    }
  }

  render() {
    const { companyScore } = this.props;
    return <Notifications data={companyScore} />;
  }
}

const mapStateToProps = (state, { componentId }) => ({
  i18n: state.i18n,
  companyScore:
    state[REDUCER_NAME].listMultiComponent[componentId].companyScore,
  searchParams:
    state[REDUCER_NAME].listMultiComponent[componentId].searchParams,
});

export default compose(
  withComponentId,
  connect(mapStateToProps),
)(NotificationsWrapper);
